/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';

// @ts-expect-error No declaration file
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getWhatsAppNumbers, getWhatsAppNumbersRequestStatus } from 'ContentData/selectors/phoneNumbers';
import * as PhoneNumbersActions from 'ContentData/actions/PhoneNumbers';
import UrlTypes from 'ContentUtils/enums/UrlTypes';
import { liveMessages } from 'ContentUtils/Routes';
import { SUCCEEDED, UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PHONE_NUMBER_REGEX = new RegExp(/^\+(\d){8,16}$/);
const i18nKey = key => `ContentComponents.cmv2.fields.url.${key}`;
const PhoneNumberRadioOptions = ({
  onNumberTypeChange,
  readOnly,
  supportedTypes,
  urlType
}) => {
  const shouldShowPhoneNumber = supportedTypes.includes(UrlTypes.PHONE_NUMBER);
  const shouldShowWhatsappNumber = supportedTypes.includes(UrlTypes.WHATSAPP_NUMBER);
  if (!shouldShowPhoneNumber || !shouldShowWhatsappNumber) return null;
  return /*#__PURE__*/_jsxs(ToggleGroup, {
    name: "phone-number-source",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(RadioInput, {
      "data-selenium": "cmv2-phone-number-radio-input",
      checked: urlType === UrlTypes.PHONE_NUMBER,
      name: `${Math.random()}`,
      onChange: () => onNumberTypeChange(UrlTypes.PHONE_NUMBER),
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`numberType.${UrlTypes.PHONE_NUMBER}`)
      })
    }), /*#__PURE__*/_jsx(RadioInput, {
      "data-selenium": "cmv2-whatsapp-number-radio-input",
      checked: urlType === UrlTypes.WHATSAPP_NUMBER,
      name: `${Math.random()}`,
      onChange: () => onNumberTypeChange(UrlTypes.WHATSAPP_NUMBER),
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`numberType.${UrlTypes.WHATSAPP_NUMBER}`)
      })
    })]
  });
};
const WhatsAppOrPhoneNumberInput = ({
  onChange,
  readOnly,
  urlType,
  useOnDark,
  value,
  whatsAppNumbers,
  error
}) => {
  const whatsAppNumbersRequestStatus = useSelector(getWhatsAppNumbersRequestStatus);
  if (urlType === UrlTypes.WHATSAPP_NUMBER) {
    const whatsappOptions = whatsAppNumbers.map(whatsAppData => {
      const {
        phoneNumber,
        phoneNumberDisplayName
      } = whatsAppData;
      return {
        text: `${phoneNumberDisplayName} ${phoneNumber}`,
        value: phoneNumber
      };
    });
    const onUpdateNumber = number => {
      onChange(number);
    };
    if (whatsAppNumbersRequestStatus !== SUCCEEDED) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      });
    } else if (whatsAppNumbersRequestStatus === SUCCEEDED && !whatsAppNumbers.length) {
      return /*#__PURE__*/_jsx(Alert, {
        "data-selenium": "cmv2-whatsapp-number-alert",
        type: "info",
        paddingBlock: "300",
        children: /*#__PURE__*/_jsxs(TFlex, {
          direction: "column",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('whatsAppAlert.text')
          }), /*#__PURE__*/_jsx(Button, {
            external: true,
            href: liveMessages(),
            size: "extra-small",
            use: "tertiary",
            marginBlockStart: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('whatsAppAlert.button')
            })
          })]
        })
      });
    } else {
      return /*#__PURE__*/_jsx(Select, {
        "data-test-id": "cmv2-whatsapp-number-input",
        buttonUse: useOnDark ? 'form-on-dark' : 'form',
        error: error,
        onChange: evt => onUpdateNumber(evt.target.value),
        placeholder: I18n.text(i18nKey('placeholder')),
        options: whatsappOptions,
        disabled: readOnly,
        value: value,
        searchable: true
      });
    }
  } else {
    const onUpdateNumber = ({
      phoneNumber
    }) => {
      onChange(phoneNumber);
    };
    return /*#__PURE__*/_jsx(PhoneNumberInput, {
      "data-selenium": "cmv2-phone-number-input",
      countrySelectProps: {
        buttonUse: useOnDark ? 'form-on-dark' : 'form',
        readOnly
      },
      onChange: onUpdateNumber,
      phoneInputProps: {
        error,
        readOnly,
        use: useOnDark ? 'on-dark' : 'default'
      },
      value: value
    });
  }
};
const getValueValidationMessage = (urlType, whatsAppNumbers, value) => {
  if (urlType === UrlTypes.PHONE_NUMBER && value && !PHONE_NUMBER_REGEX.test(value)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('input.validation.PHONE_NUMBER')
    });
  }
  if (urlType === UrlTypes.WHATSAPP_NUMBER && value && whatsAppNumbers.length && !whatsAppNumbers.find(data => data.phoneNumber === value)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('input.validation.WHATSAPP_NUMBER')
    });
  }
};
const PhoneNumberSelect = ({
  onChange,
  onTypeChange,
  readOnly = false,
  supportedTypes,
  urlType,
  useOnDark,
  value,
  error
}) => {
  const dispatch = useDispatch();
  const whatsAppNumbersRequestStatus = useSelector(getWhatsAppNumbersRequestStatus);
  const whatsAppNumbers = useSelector(getWhatsAppNumbers);
  useEffect(() => {
    if (urlType === UrlTypes.WHATSAPP_NUMBER && whatsAppNumbersRequestStatus === UNINITIALIZED) {
      dispatch(PhoneNumbersActions.fetchWhatsappNumbers());
    }
  }, [dispatch, urlType, whatsAppNumbersRequestStatus]);
  const onNumberTypeChange = numberType => {
    onTypeChange(SyntheticEvent(numberType));
  };
  const formLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey(`input.labelsByType.${urlType}`)
  });
  const validationMessageMaybe = getValueValidationMessage(urlType, whatsAppNumbers, value);
  const hasError = error || !!validationMessageMaybe;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PhoneNumberRadioOptions, {
      onNumberTypeChange: onNumberTypeChange,
      readOnly: readOnly,
      supportedTypes: supportedTypes,
      urlType: urlType
    }), /*#__PURE__*/_jsx(FormControl, {
      error: hasError
      // when error is passed, validation messaging is handled by parent
      ,
      validationMessage: !error && validationMessageMaybe,
      label: formLabel,
      children: /*#__PURE__*/_jsx(WhatsAppOrPhoneNumberInput, {
        onChange: onChange,
        readOnly: readOnly,
        urlType: urlType,
        useOnDark: useOnDark,
        value: value,
        whatsAppNumbers: whatsAppNumbers,
        error: hasError
      })
    })]
  });
};
export default PhoneNumberSelect;